export default __webpack_public_path__ + "static/media/truck-03.ec31f5a2.jpg";